<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.context.status_from="{ data, value: v }">
      <v-tooltip v-if="data.context.status_from" top>
        <template #activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            v-text="v"
          />
        </template>
        <slot>
          <span v-text="data.context.status_from" />
        </slot>
      </v-tooltip>
      <span v-else v-text="v" />
    </template>

    <template #item.context.status_to="{ data, value: v }">
      <v-tooltip v-if="data.context.status_to" top>
        <template #activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            v-text="v"
          />
        </template>
        <slot>
          <span v-text="data.context.status_to" />
        </slot>
      </v-tooltip>
      <span v-else v-text="v" />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/LKPublications/formdata/table-headers-history'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationFormdataHistory',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
